<template>
    <div>
        <modal
            v-if="user"
            :is-open="isOpen"
            :is-loading="loading"
            :disabled="loading"
            title="Отправить сообщение"
            btn-save-title="Отправить"
            @onCloseModal="closeModal"
            @onSaveModal="saveModal"
        >
            <div class="cabinet-form-group">
                <label class="cabinet-form-group__label">Кому:</label>
                <div class="dashboard__form-bold">
                    {{ retailer.company_name || retailer.name }}
                </div>
                {{ retailer.city }}
            </div>
            <div class="cabinet-form-group">
                <label class="cabinet-form-group__label required" for="from"
                    >От кого</label
                >
                <input
                    id="from"
                    type="text"
                    class="cabinet-form-group__input"
                    :value="[user.company_name, user.name].join(', ')"
                    disabled
                />
            </div>
            <div class="cabinet-form-group">
                <label class="cabinet-form-group__label required" for="message"
                    >Сообщение</label
                >
                <textarea
                    id="message"
                    v-model.trim="message"
                    class="cabinet-form-group__textarea cabinet-form-group__textarea--resizable"
                    :class="{
                        error:
                            ($v.message.$dirty && $v.message.$invalid) ||
                            (errors.sendMessage.message && !$v.message.$dirty)
                    }"
                ></textarea>
                <div
                    v-if="$v.message.$dirty && $v.message.$invalid"
                    class="error-label"
                >
                    Поле необходимо заполнить
                </div>
                <div
                    v-if="errors.sendMessage.message && !$v.message.$dirty"
                    class="error-label"
                >
                    {{ errors.sendMessage.message[0] }}
                </div>
            </div>
            <p class="pt-2">
                Ваше сообщение будет отправлено на электронную почту ритейлера.
                Ответное сообщение ритейлера будет отправлено вам на электроную
                почту {{ user.email }}.
            </p>
        </modal>
    </div>
</template>

<script>
import Modal from '@/components/Elements/Modal'
import { mapState, mapGetters, mapActions } from 'vuex'

import { required } from 'vuelidate/lib/validators'

const validations = {
    message: { required }
}

export default {
    name: 'MessageModal',
    components: { Modal },
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        retailer: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            loading: false,
            message: ''
        }
    },
    computed: {
        ...mapState('user', ['user']),
        ...mapState('supplierMessages', ['errors'])
    },
    validations,
    methods: {
        ...mapActions('supplierMessages', ['sendMessage', 'resetErrors']),
        closeModal() {
            this.message = ''
            this.$v.$reset()
            this.resetErrors()
            this.$emit('closeModal')
        },
        async saveModal() {
            if (this.loading) return
            this.$v.$touch()
            if (!this.$v.$invalid) {
                this.loading = true
                this.$v.$reset()

                let data = {
                    retailerId: this.retailer.id,
                    message: this.message
                }

                await this.sendMessage(data)
                this.loading = false

                if (Object.keys(this.errors.sendMessage).length) {
                    this.$notify({
                        type: 'error',
                        text: 'Ошибка'
                    })
                } else {
                    this.$notify({
                        type: 'success',
                        text: 'Сообщение успешно отправлено'
                    })
                    this.closeModal()
                }
            } else {
                this.$notify({
                    type: 'error',
                    text: 'Форма заполнена некорректно'
                })
            }
        }
    }
}
</script>
